import {Routes, Route, Outlet, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../../_metronic/layout/core'
import {SuspensedView} from '../../../../routing/PrivateRoutes'
import ShippingDocScreenWrapper from './shipping-doc.screen'
import ShippingDocExportScreenWrapper from './shipping-doc-export.screen'
import ShippingDocShopeeScreenWrapper from './shipping-doc-shopee.screen'
import ShippingDocShopeeExportScreenWrapper from './shipping-doc-export-shopee.screen'

const shippingDocBreadcrumbs: Array<PageLink> = [
  {
    title: 'Generate Resi',
    path: '/apps/shipping-docs-management/shipping-doc',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const ShippingDocPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='shipping-doc'
          element={
            <SuspensedView>
              <PageTitle breadcrumbs={shippingDocBreadcrumbs}>Generate Resi</PageTitle>
              <ShippingDocScreenWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='shipping-doc-shopee'
          element={
            <SuspensedView>
              <PageTitle breadcrumbs={shippingDocBreadcrumbs}>Generate Resi</PageTitle>
              <ShippingDocShopeeScreenWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='shipping-doc-export'
          element={
            <SuspensedView>
              <PageTitle breadcrumbs={shippingDocBreadcrumbs}>Cetak Resi</PageTitle>
              <ShippingDocExportScreenWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='shipping-doc-export-shopee'
          element={
            <SuspensedView>
              <PageTitle breadcrumbs={shippingDocBreadcrumbs}>Cetak Resi</PageTitle>
              <ShippingDocShopeeExportScreenWrapper />
            </SuspensedView>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/shipping-docs-management/shipping-doc' />} />
    </Routes>
  )
}

export default ShippingDocPage
